import { actions } from './actions'

const initialState = {
  firewallips: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function usuarioReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FIREWALLIP_LOAD_REQUESTED:
      return { ...state, firewallips: { ...state.firewallips, loading: true } }
    case actions.FIREWALLIP_LOAD_SUCCEEDED:
      return {
        ...state,
        firewallips: {
          ...state.firewallips,
          data: action.payload,
          loading: false,
        },
      }
    case actions.FIREWALLIP_LOAD_FAILED:
      return {
        ...state,
        firewallips: { ...state.firewallips, loading: false, error: action.error },
      }

    default:
      return state
  }
}
